<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Заполните данные о&nbsp;договоре&nbsp;страхования</h3>
      <div class="step__contract" :class="{ 'step__contract_first': i === 1 }" v-for="i in contractCount" :key="form.contracts[i - 1].key">
        <div class="step__line step__line_divider" v-if="i !== 1"></div>
        <h3 v-if="i !== 1" class="step__title step__title_special">
          Заполните данные о&nbsp;договоре&nbsp;страхования
          <div class="step__contract-close" @click="$store.commit('deleteContract', form.contracts[i - 1].key)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 5V13M10 5V13M1 3H15M6 1H10M3 3H13V15H3V3Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </h3>
        <TextInput :required="true" @setError="errors[`contract-${i}-id`] = $event" v-model="form.contracts[i - 1].id" text="Номер договора страхования" :validation="contractIdValidation" :name="`contract-${i}-id`" />
        <DateInput :required="true" @setError="errors[`contract-${i}-date`] = $event" :name="`contract-${i}-date`" text="Дата заключения договора страхования" :range="false" v-model="form.contracts[i - 1].date" />
      </div>
      <AddBtn class="addbtn_mobincmargin" @click="() => this.$store.commit('addContract', key++)">Добавить еще договор</AddBtn>
      <div class="step__line"></div>
      <div class="step__buttonflex">
        <Btn class="step__next step__next_special step__next_special-formlink" @click.stop.prevent="$emit('toAdForm')"><span>Я уже заполнил заявку<span class="mobdisappear">, нужно добавить документы</span></span></Btn>
        <Btn class="step__next step__next_special" :disabled="!filled" @click.stop.prevent="$store.commit('nextStep')">Далее</Btn>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import AddBtn from '../AddBtn.vue';
import Btn from '../Btn.vue';
import DateInput from '../inputs/DateInput.vue';
export default {
  components: { TextInput, AddBtn, DateInput, Btn },
  props: {
    active: { type: Boolean }
  },
  data: () => ({
    errors: {},
    key: 1
  }),
  computed: {
    ...mapState(['form']),
    ...mapGetters(['contractCount']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      for (let contract of this.form.contracts)
        if (!contract.id || !contract.date) return false
      return true
    }
  },
  methods: {
    contractIdValidation(val) {
      if (val.length > 50) return 'Не более 50 символов'
    },
  }
}
</script>

<style lang="sass">
.step 
  width: 100%
  &__addressline
    display: flex
    align-items: flex-end
    margin-bottom: 32px
    &-main
      flex-grow: 1  
      height: 100%
      margin-bottom: 0
    &-flat
      height: 100%  
      margin-left: 32px
      width: 50px
      margin-bottom: 0
      .aoformlabel__error:nth-child(n) ~ .aoformfield
        border-bottom: 1px solid colors.$newred
        box-shadow: 0px 2px 0px -1px colors.$newred
      .aoformlabel__error
        display: none !important



  & &__buttonflex
    display: flex
    align-items: center
    justify-content: center
    margin: 32px 0
    >*:not(:last-child)
      margin-right: 16px
  & &__delbutton
    margin-bottom: 0
    margin-left: auto
  &:not(&_active)
    max-height: calc(100vh - var(--headeroffset))  
    overflow: hidden
  &__inner
    width: 604px
    max-width: 100%
    margin: 0 auto
  &__contract
    position: relative
    &-close
      flex-shrink: 0
      position: absolute
      top: 2px
      right: 2px
      z-index: 5
      width: 20px
      height: 20px
      cursor: pointer
      color: black
      svg
        width: 100%
        display: block

  &__title
    font-weight: 400
    font-size: 24px
    line-height: 1.16
    text-align: center
    margin-bottom: 38px
    color: colors.$gray3
    &_special
      position: relative
      padding-left: 30px
      padding-right: 30px
    &_left
      text-align: left
    &_smspace
      margin-bottom: 8px
    &_incspace
      margin-bottom: 64px
    &_topmg
      margin-top: 60px
  &__minititle
    font-size: 20px
    line-height: 1.18
    font-weight: 400
    color: colors.$gray3
    margin-bottom: 16px
  &__microtitle
    font-size: 16px
    font-weight: 400
    line-height: 1.28
    margin-bottom: 40px
  &__subtitle
    font-size: 14px
    line-height: 1.12
    color: colors.$newgray
    margin-bottom: 40px
    text-align: center
  &__text
    font-size: 16px
    line-height: 1.28
    color: colors.$gray5
    margin-bottom: 8px
  &__sm
    font-size: 14px
  &__line
    border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
    width: 100%
    margin: 40px 0 64px
    &_divider
      margin-bottom: 40px
  &__next
    width: 328px
    max-width: 100%
    margin: 32px auto
    &_special:nth-child(n)
      margin: 0
      min-width: 210px
    &_special-formlink:nth-child(n)
      font-size: 14px
  @include for-mob
    &__title
      font-size: 22px
      line-height: 1.16
      margin-bottom: 32px
      &_smspace
        margin-bottom: 8px
      &_special
        font-size: 18px
        text-align: left
        padding-left: 0
        padding-right: 0
        display: flex
        align-items: center
    &__subtitle
      margin-bottom: 32px
    &__text
      line-height: 1.12
    &__minititle_spaced
      padding: 32px 0 16px
    &__minititle_spaced-bottom
      padding: 0 0 16px
    &__contract
      &-close
        margin-left: auto
        padding-left: 10px
        width: 30px
        position: static
  & &__buttonflex >*:not(:last-child)
    margin-right: 10px
  &__next_special:nth-child(n)
    width: auto
    flex-basis: 150px
    flex-grow: 1
    min-width: 140px
    max-width: 250px
    padding-left: 10px
    padding-right: 10px


</style>